<template>
  <TransitionGroup name="AppMessages_transition" class="AppMessages" tag="div">
    <template v-for="msg in messageService.messages" :key="msg.id">
      <div class="AppMessages_message" :class="`-${msg.level}`">
        <div class="AppMessages_content">
          <div v-if="msg.options?.content === 'html'" v-html="msg.text"></div>
          <span v-else>
            {{ msg.text }}
          </span>
        </div>
        <Button
          class="AppMessages_close"
          :class="{ 'opacity-0 hover:opacity-100': msg.options.timeout !== 0 }"
          variant="text"
          @click="messageService.removeMessage(msg.id)"
        >
          <Icon name="close" />
        </Button>
      </div>
    </template>
  </TransitionGroup>
</template>

<script lang="ts" setup>
import { Icon, Button } from '@madxnl/dodo-ui'
import { messageService } from './messageService'
</script>

<style lang="scss">
.AppMessages {
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  padding: 0.5em;
  z-index: 100;
  pointer-events: none;
  display: flex;
  flex-flow: column;
  align-items: center;
}

.AppMessages_transition-move,
.AppMessages_transition-enter-active,
.AppMessages_transition-leave-active {
  transition: all var(--dodo-transition-duration);
  max-height: 300px;
  overflow: hidden;
}
.AppMessages_transition-enter,
.AppMessages_transition-leave-to {
  opacity: 0;
  max-height: 0;
  margin: 0 !important;
}

.AppMessages_message {
  max-width: 600px;
  margin-top: 0.5em;
  margin-left: auto;
  margin-right: auto;
  pointer-events: auto;
  color: white;
  cursor: default;
  font-weight: 500;
  background: var(--dodo-color-foreground);
  border-radius: 4px;
  box-shadow: var(--dodo-shadow-3);
  min-width: 300px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &.-info {
    background: var(--dodo-color-info);
    color: white;
  }
  &.-success {
    background: var(--dodo-color-success);
    color: white;
  }
  &.-warn {
    background: var(--dodo-color-warn);
    color: white;
  }
  &.-error {
    background: var(--dodo-color-danger);
    color: white;
  }

  .AppMessages_content {
    padding: 0.5em 0.75em;
    max-height: 300px;
    overflow: hidden;
    &::first-letter {
      text-transform: capitalize;
    }
  }
  .AppMessages_close {
    cursor: pointer;
    color: inherit;
    transition: all var(--dodo-transition-duration);
  }
}
</style>
